import { composeSelector } from "seneca-common/utils/selectors/compose-selectors";

import { PATH_PARENT_UI_STATE } from "../consts";
import ParentUiState, { AssignmentsFilter } from "../models/ParentUiState";
import { getAssignmentsFilterState } from "./state/assignmentsFilter";
import * as dropdownsSelectors from "./state/dropdowns";

type State = any;

export function getParentUiSlice(state: State): ParentUiState {
  return state.get(PATH_PARENT_UI_STATE);
}

/* DROPDOWNS */

export const getSelectedChildInitialised: (state: State) => boolean =
  composeSelector(
    getParentUiSlice,
    dropdownsSelectors.getSelectedChildInitialised
  );

export const getChildUserId: (state: State) => string = composeSelector(
  getParentUiSlice,
  dropdownsSelectors.getChildUserId
);

export const getStartTime: (state: State) => string = composeSelector(
  getParentUiSlice,
  dropdownsSelectors.getStartTime
);

export const getEndTime: (state: State) => string = composeSelector(
  getParentUiSlice,
  dropdownsSelectors.getEndTime
);

export const isCustomPeriod: (state: State) => boolean = composeSelector(
  getParentUiSlice,
  dropdownsSelectors.isCustomPeriod
);

export const getSelectedAssignmentsFilter: (state: State) => AssignmentsFilter =
  composeSelector(getParentUiSlice, getAssignmentsFilterState);
